module.exports = __webpack_public_path__ + "static/media/romobil_potraznja.17dc4374.png";